(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["montal-faq"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('montal-accordion')) {
    class MontalAccordion extends HTMLElement {
      connectedCallback() {
        this.triggers = Array.from(this.querySelectorAll('[data-accordion-trigger]'));
        if (!this.triggers.length) return;

        this.allowMultiple = this.hasAttribute('data-allow-multiple');
        this.controller = new AbortController();
        const { signal } = this.controller;

        this.triggers.forEach((trigger) => {
          trigger.addEventListener('click', () => this.toggle(trigger), { signal });
          trigger.addEventListener('keydown', (event) => this.onKeydown(event, trigger), { signal });
        });
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
      }

      panelFor(trigger) {
        return document.getElementById(trigger.getAttribute('aria-controls'));
      }

      toggle(trigger) {
        const isOpen = trigger.getAttribute('aria-expanded') === 'true';

        if (this.allowMultiple) {
          const panel = this.panelFor(trigger);
          trigger.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (panel) panel.hidden = isOpen;
          return;
        }

        this.triggers.forEach((other) => {
          const panel = this.panelFor(other);
          const open = other === trigger && !isOpen;
          other.setAttribute('aria-expanded', open ? 'true' : 'false');
          if (panel) panel.hidden = !open;
        });
      }

      onKeydown(event, trigger) {
        const keys = { ArrowDown: 1, ArrowUp: -1 };
        if (event.key in keys) {
          event.preventDefault();
          const index = this.triggers.indexOf(trigger);
          const next = (index + keys[event.key] + this.triggers.length) % this.triggers.length;
          this.triggers[next].focus();
        } else if (event.key === 'Home') {
          event.preventDefault();
          this.triggers[0].focus();
        } else if (event.key === 'End') {
          event.preventDefault();
          this.triggers[this.triggers.length - 1].focus();
        }
      }
    }

    customElements.define('montal-accordion', MontalAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["montal-packages"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('montal-scroller')) {
    class MontalScroller extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-scroller-track]');
        this.dots = Array.from(this.querySelectorAll('[data-scroller-dots] > *'));
        this.status = this.querySelector('[data-scroller-status]');
        if (!this.track || !this.dots.length) return;

        this.items = Array.from(this.track.children);
        this.controller = new AbortController();
        this.raf = null;
        this.onScroll = this.onScroll.bind(this);

        this.track.addEventListener(
          'scroll',
          () => {
            if (this.raf) return;
            this.raf = requestAnimationFrame(this.onScroll);
          },
          { passive: true, signal: this.controller.signal }
        );
        this.onScroll();
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
      }

      onScroll() {
        this.raf = null;
        const trackLeft = this.track.getBoundingClientRect().left;
        const pad = parseFloat(getComputedStyle(this.track).paddingLeft) || 0;
        let active = 0;
        let best = Infinity;

        this.items.forEach((item, index) => {
          const d = Math.abs(item.getBoundingClientRect().left - trackLeft - pad);
          if (d < best) {
            best = d;
            active = index;
          }
        });

        this.dots.forEach((dot, i) => dot.classList.toggle('is-active', i === active));

        if (this.status) {
          const label = this.items[active] && this.items[active].querySelector('[id$="-name"]');
          const name = label ? label.textContent.trim() : String(active + 1);
          const text = 'Paquete ' + (active + 1) + ' de ' + this.items.length + ': ' + name;
          if (this.status.textContent !== text) this.status.textContent = text;
        }
      }
    }

    customElements.define('montal-scroller', MontalScroller);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["montal-product-related"] && !Shopify.designMode) return;
  try {
    
  class MontalRelated extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url || this.dataset.loaded === 'true') return;
      this.dataset.loaded = 'true';

      fetch(url)
        .then((res) => (res.ok ? res.text() : Promise.reject(res.status)))
        .then((text) => {
          const fresh = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('montal-related');
          if (!fresh) return;
          this.innerHTML = fresh.innerHTML;
          window.MontalBase?.observeReveal(this);
        })
        .catch(() => {
          /* Sin recomendaciones el bloque simplemente no aparece. */
        });
    }
  }

  if (!customElements.get('montal-related')) {
    customElements.define('montal-related', MontalRelated);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["montal-product-sticky"] && !Shopify.designMode) return;
  try {
    
  class MontalStickyBuy extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const on = { signal: this.controller.signal };
      this.bar = this.querySelector('.montal-psticky');
      this.button = this.querySelector('[data-sticky-add]');
      if (!this.bar) return;

      this.form = document.querySelector('montal-variants form');
      this.source = document.querySelector('[data-add-button]');

      this.button?.addEventListener('click', () => {
        if (this.form?.requestSubmit) { this.form.requestSubmit(); } else { this.form?.submit(); }
      }, on);

      this.sync();
      document.addEventListener('montal:variant:change', () => this.sync(), on);

      const anchor = document.querySelector('.montal-pbuy__panel') || document.querySelector('montal-variants');
      if (anchor && 'IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
              this.bar.hidden = !show;
              this.bar.classList.toggle('is-visible', show);
            });
          },
          { rootMargin: `-${this.dataset.threshold || 0}px 0px 0px 0px` }
        );
        this.observer.observe(anchor);
      }
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }

    /* El estado del botón fijo siempre refleja el del botón real. */
    sync() {
      if (!this.button) return;
      this.source = document.querySelector('[data-add-button]');
      if (!this.source) return;
      this.button.disabled = this.source.disabled;
      if (this.source.disabled) this.button.textContent = this.source.textContent.trim();
    }
  }

  if (!customElements.get('montal-sticky-buy')) {
    customElements.define('montal-sticky-buy', MontalStickyBuy);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["montal-profit-calculator"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('montal-calculator')) {
    class MontalCalculator extends HTMLElement {
      connectedCallback() {
        try {
          this.packages = JSON.parse(this.dataset.packages || '[]');
        } catch (error) {
          this.packages = [];
        }
        if (!this.packages.length) return;

        this.symbol = this.dataset.currencySymbol || '$';
        this.priceInput = this.querySelector('[data-calc-price]');
        this.priceOut = this.querySelector('[data-calc-price-out]');
        this.packageInputs = Array.from(this.querySelectorAll('[data-calc-package]'));
        this.profitOut = this.querySelector('[data-calc-profit]');
        this.breakdown = this.querySelector('[data-calc-breakdown]');
        this.live = this.querySelector('[data-calc-live]');

        this.piecesWord = this.dataset.piecesWord || 'piezas';
        this.controller = new AbortController();
        const { signal } = this.controller;
        const update = () => this.update();

        if (this.priceInput) this.priceInput.addEventListener('input', update, { signal });
        this.packageInputs.forEach((input) => input.addEventListener('change', update, { signal }));

        this.liveTimer = null;
        this.update(true);
      }

      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        if (this.liveTimer) clearTimeout(this.liveTimer);
      }

      get selectedIndex() {
        const checked = this.packageInputs.find((input) => input.checked);
        return checked ? parseInt(checked.value, 10) : 0;
      }

      // Formato propio: el bundle puede cargar esta sección antes que el snippet base.
      fmt(value) {
        return String(Math.round(value)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      }

      update(immediate) {
        const pack = this.packages[this.selectedIndex] || this.packages[0];
        if (!pack) return;

        const salePrice = this.priceInput ? Number(this.priceInput.value) : 0;
        const pieces = Number(pack.pieces) || 0;
        const investment = Number(pack.investment) || 0;
        const sales = pieces * salePrice;
        const profit = sales - investment;

        if (this.priceOut) {
          this.priceOut.textContent = this.symbol + this.fmt(salePrice);
        }

        if (this.profitOut) {
          const base = window.MontalBase;
          if (immediate || !base || !base.animateCount) {
            this.profitOut.textContent = this.fmt(profit);
            this.profitOut.dataset.montalCurrent = profit;
          } else {
            base.animateCount(this.profitOut, profit, { duration: 420 });
          }
        }

        if (this.breakdown) {
          this.breakdown.textContent =
            pieces +
            ' ' +
            this.piecesWord +
            ' × ' +
            this.symbol +
            this.fmt(salePrice) +
            ' = ' +
            this.symbol +
            this.fmt(sales) +
            ' en ventas, menos ' +
            this.symbol +
            this.fmt(investment) +
            ' de inversión.';
        }

        if (this.live) {
          if (this.liveTimer) clearTimeout(this.liveTimer);
          this.liveTimer = setTimeout(() => {
            this.live.textContent =
              pack.name +
              ': vendiendo cada pieza en ' +
              this.symbol +
              this.fmt(salePrice) +
              ', la utilidad estimada es ' +
              this.symbol +
              this.fmt(profit) +
              '.';
          }, 600);
        }
      }
    }

    customElements.define('montal-calculator', MontalCalculator);
  }

  } catch(e) { console.error(e); }
})();
})();
